/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  create_organisation_user_action,
  create_organisation_action,
  get_organisation_users_action,
  delete_organisation_user_action,
  update_organisation_action,
  get_my_organisation_action,
  update_organisation_user_action,
} from '../../_redux/action';
import { AuthContext } from '../../_hooks/useAuthContext';
import { platformPermissions } from '../../_helpers/types';
function useSavedUsers(props) {
  const { user, checkPermission } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [allUsers, setAllUsers] = useState();
  const [organisationDetails, setOrganisationDetails] = useState();
  const [userForm, setUserForm] = useState(null);
  const [userModalOpen, setUserModalOpen] = useState(null);
  const [deleteUser, setDeleteUser] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(null);
  const [organisationModalOpen, setOrganisationModalOpen] = useState(null);

  // State to manage validation errors
  const [formErrors, setFormErrors] = useState({});

  const dispatch = useDispatch();

  const { organisationUsersData } = useSelector((state) => state.get_organisation_users_reducer);
  const { organisationDetailsData } = useSelector((state) => state.get_organisation_reducer);

  useEffect(() => {
    if (organisationUsersData) {
      setAllUsers(organisationUsersData);
    }
  }, [organisationUsersData]);

  useEffect(() => {
    if (organisationDetailsData) {
      setOrganisationDetails(organisationDetailsData);
    }
  }, [organisationDetailsData]);

  useEffect(() => {
    if (!user) return;
    
    const callApi = async () => {
      setLoading(true);
      await dispatch(get_my_organisation_action());
      if (checkPermission(platformPermissions.viewUsers)) {
        await dispatch(get_organisation_users_action());
      }
      setLoading(false);
    };
    callApi();
  }, [user]);
  // Handles input change and clears validation errors
  const onInputChange = async (e) => {
    setUserForm({ ...userForm, [e.target.name]: e.target.value });

    // Clear the error for the field being updated
    if (formErrors[e.target.name]) {
      setFormErrors({ ...formErrors, [e.target.name]: null });
    }
  };

  const validateUserForm = () => {
    let errors = {};
    if (!userForm?.full_name) errors.full_name = 'Full name is required';
    if (!userForm?.email) errors.email = 'Email is required';
    if (!userForm?.role) errors.role = 'Role is required';

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // If no errors, return true
  };

  const onUserSave = async () => {
    if (!validateUserForm()) return; // Exit if the form is invalid

    let savedData = null;

    if (userForm?._id) {
      savedData = await dispatch(update_organisation_user_action(userForm?._id, userForm));
    } else {
      savedData = await dispatch(create_organisation_user_action(userForm));
    }

    if (!savedData) {
      setFormErrors({
        form_error: 'Failed to save user. Email is not valid or already exists.',
      });
      return;
    }
    await dispatch(create_organisation_user_action(userForm));
    await dispatch(get_organisation_users_action());
    setFormErrors({});
    setUserForm({});
    setUserModalOpen((v) => !v);
  };

  const handleUserModalOpen = (item) => {
    if (item) {
      setUserForm(item);
    } else {
      setUserForm({}); // Clear form for adding a new user
    }
    setFormErrors({}); // Reset errors when opening the modal
    setUserModalOpen((v) => !v);
  };

  const onUserViewClick = async (item) => {
    if (item?.bookmark_url) {
      window.open(item.bookmark_url, null);
    }
  };

  const onDeleteUserConfirm = async () => {
    if (deleteUser?._id) {
      await dispatch(delete_organisation_user_action(deleteUser._id));
      await dispatch(get_organisation_users_action());
    }
    setDeleteUser(null);
    setDeleteModalOpen((v) => !v);
  };

  const onUserDelete = async (item) => {
    setDeleteUser(item);
    setDeleteModalOpen((v) => !v);
  };

  const onDeleteModelClose = () => {
    setDeleteModalOpen((prev) => !prev);
  };

  const onOrganisationSave = async () => {
    if (!validateOrganisationForm()) return;

    let savedData = null;

    if (organisationDetails?._id) {
      savedData = await dispatch(
        update_organisation_action(organisationDetails?._id, {
          name: organisationDetails?.name,
          url: organisationDetails?.url,
        })
      );
    } else {
      savedData = await dispatch(create_organisation_action(organisationDetails));
    }

    if (!savedData) {
      setFormErrors({
        form_error: 'Failed to save Organization. Url is not valid or already exists.',
      });
      return;
    }

    await dispatch(get_my_organisation_action());
    await dispatch(get_organisation_users_action());
    setOrganisationModalOpen((v) => !v);
    setFormErrors({});
  };

  const onOrganisationInputChange = async (e) => {
    setOrganisationDetails({ ...organisationDetails, [e.target.name]: e.target.value });
  };

  const validateOrganisationForm = () => {
    let errors = {};
    if (!organisationDetails?.name) errors.name = 'Name is required';
    if (!organisationDetails?.url) {
      errors.url = 'Url is required';
    } else if (!/^https?:\/\/.+\..+/.test(organisationDetails.url)) {
      errors.url = 'Url must be a valid URL';
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleOrganisationModalOpen = () => {
    setOrganisationModalOpen((v) => !v);
  };

  return {
    user,
    loading,
    allUsers,
    userForm,
    userModalOpen,
    deleteUser,
    deleteModalOpen,
    formErrors,
    organisationDetails,
    organisationModalOpen,
    onInputChange,
    onUserSave,
    onUserDelete,
    handleUserModalOpen,
    onUserViewClick,
    onDeleteUserConfirm,
    onDeleteModelClose,
    onOrganisationSave,
    onOrganisationInputChange,

    handleOrganisationModalOpen,
  };
}
export default useSavedUsers;
